import React from "react";
import Userprofile from "./user-route/Userprofile";
import UserBase from "../components/user/UserBase";
import TrusteeBase from "../components/trustee/TrusteeBase";
import BeneficiryBase from "../components/beneficiary/BeneficiaryBase";
import OrganizationBase from "./organization/OrganizationBase";
import { getUser } from "../services/user-service";

function Profile() {
  let role = getUser().role;

  if (role === "USER") {
    return (
      <UserBase>
        <Userprofile />
      </UserBase>
    );

  } else if (role === "BENEFICIARY") {
    return (
      <BeneficiryBase>
        <Userprofile />
      </BeneficiryBase>
    );

  } else if (role === "ATTORNEY") {
    return (
      <TrusteeBase>
        <Userprofile />
      </TrusteeBase>
    );

  }else if (role === "TENANT_ADMIN"  || role === "TENANT_USER" || role === "ORG_USER") {
    return (
      <OrganizationBase>
        <Userprofile />
      </OrganizationBase>
    );
  }
}

export default Profile;
